import { Bundler, IBundler } from "@biconomy/bundler";
import {
  Paymaster,
  createSmartAccountClient,
  DEFAULT_ENTRYPOINT_ADDRESS,
  ECDSAOwnershipValidationModule,
  DEFAULT_ECDSA_OWNERSHIP_MODULE,
} from "@biconomy/account";
import { avalancheFuji, avalanche } from "viem/chains";
import { isProduction } from "@/helpers/environment";
import { WalletClient } from "viem";

const bundler: IBundler = new Bundler({
  bundlerUrl: isProduction
    ? "https://bundler.biconomy.io/api/v2/43114/6fcb7096-bf63-4894-bdc4-e1852a81da73"
    : "https://bundler.biconomy.io/api/v2/43113/nJPK7B3ru.dd7f7861-190d-41bd-af80-6877f74b8f44",
  chainId: isProduction ? avalanche.id : avalancheFuji.id,
  entryPointAddress: DEFAULT_ENTRYPOINT_ADDRESS,
});

const paymaster = new Paymaster({
  paymasterUrl: import.meta.env.VITE_BICONOMY_PAYMASTER_URL,
});

const createValidationModule = async (walletClient: WalletClient) => {
  return await ECDSAOwnershipValidationModule.create({
    signer: walletClient,
    moduleAddress: DEFAULT_ECDSA_OWNERSHIP_MODULE,
  });
};

export const createSmartAccount = async (walletClient: WalletClient) => {
  const validationModule = await createValidationModule(walletClient);
  return await createSmartAccountClient({
    signer: walletClient,
    chainId: isProduction ? avalanche.id : avalancheFuji.id,
    // @ts-ignore
    bundler: bundler,
    paymaster: paymaster,
    biconomyPaymasterApiKey: import.meta.env.VITE_PM_BICONOMY_API_KEY,
    entryPointAddress: DEFAULT_ENTRYPOINT_ADDRESS,
    defaultValidationModule: validationModule,
    activeValidationModule: validationModule,
  });
};
